module.exports = __webpack_public_path__ + "images/file_icons_v2/max-6c6eea40ef94fa891e41c3c243076b97.svg";